import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import OtpInput from "react-otp-input";
import { logo } from "../../../assets";
import { signUpUserValidation } from "../../../utils/validation/validation";
import ValidationErrorMessage from "../../../helpers/ValidationErrorMessage/ValidationErrorMessage";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { MdInstallDesktop, MdInstallMobile } from "react-icons/md";
import { authContext } from "../../../context/AuthContext/AuthContext";
const SignUp = () => {
  const {
    isShowPassSignUp,
    setIsShowPassSignUp,
    isShowPassSignUpConfirm,
    setIsShowPassSignUpConfirm,
    signUpCode,
    setSignUpCode,
    isChange,
    isShowForm,
    handleSignUp,
    handleOtpSignUp,
    setDeferredPrompt,
    showInstallButton,
    setShowInstallButton,
    handleInstallClick,
  } = useContext(authContext);

  const [isAcceptRule, setIsAcceptRule] = useState(false);
  const [isShowAcceptRule, setIsShowAcceptRule] = useState(false);

  // PWA Installer
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  // Form Validation
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signUpUserValidation),
  });

  return (
    <>
      <SiteTitle title="ثبت نام کاربر" />
      <div className="bg-[#101632] min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-md mx-auto">
          <div className="bg-[#153477] backdrop-blur-sm rounded-xl shadow-lg overflow-hidden border border-gray-200 transition-transform duration-300 hover:scale-[1.01]">
            {/* Logo Header */}
            <div className="bg-[#153477] py-6 flex flex-col items-center border-b border-gray-200">
              <div className="relative w-20 h-20 flex items-center justify-center bg-white border-2 border-yellow-500 rounded-lg shadow-sm overflow-hidden">
                <img
                  src={logo}
                  alt="Website Logo"
                  className="object-contain w-16 h-16"
                />
              </div>
              <h2 className="text-2xl font-bold text-white mt-4">ثبت نام</h2>
              <p className="text-gray-500 text-sm mt-1">شادمهر</p>
            </div>

            <div className="p-6">
              <div className={`${isShowForm ? "block" : "hidden"}`}>
                <form
                  onSubmit={handleSubmit(handleOtpSignUp)}
                  className="space-y-4"
                >
                  {/* First Name */}
                  <div>
                    <label
                      htmlFor="firstname"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      نام
                    </label>
                    <input
                      type="text"
                      id="firstname"
                      placeholder="نام"
                      autoComplete="off"
                      {...register("firstname")}
                      className="w-full px-4 py-3 bg-[#171d3f] border border-gray-300 rounded-lg 
                        text-white placeholder-gray-400 focus:outline-none focus:ring-2 
                        focus:ring-yellow-500 focus:border-transparent"
                    />
                    <ValidationErrorMessage
                      message={errors.firstname?.message}
                    />
                  </div>

                  {/* Last Name */}
                  <div>
                    <label
                      htmlFor="lastname"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      نام خانوادگی
                    </label>
                    <input
                      type="text"
                      id="lastname"
                      placeholder="نام خانوادگی"
                      autoComplete="off"
                      {...register("lastname")}
                      className="w-full px-4 py-3 bg-[#171d3f] border border-gray-300 rounded-lg 
                        text-white placeholder-gray-400 focus:outline-none focus:ring-2 
                        focus:ring-yellow-500 focus:border-transparent"
                    />
                    <ValidationErrorMessage
                      message={errors.lastname?.message}
                    />
                  </div>

                  {/* National ID */}
                  <div>
                    <label
                      htmlFor="phonenumber"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      کد ملی
                    </label>
                    <input
                      type="text"
                      id="nationalid"
                      placeholder="کد ملی"
                      autoComplete="off"
                      {...register("nationalid")}
                      className="w-full px-4 py-3 bg-[#171d3f] border border-gray-300 rounded-lg 
                        text-white placeholder-gray-400 focus:outline-none focus:ring-2 
                        focus:ring-yellow-500 focus:border-transparent"
                    />
                    <ValidationErrorMessage
                      message={errors.nationalid?.message}
                    />
                  </div>

                  {/* Phone Number */}
                  <div>
                    <label
                      htmlFor="phonenumber"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      شماره موبایل
                    </label>
                    <input
                      type="number"
                      id="phonenumber"
                      placeholder="09123456789"
                      autoComplete="off"
                      {...register("phonenumber")}
                      className="w-full px-4 py-3 bg-[#171d3f] border border-gray-300 rounded-lg 
                        text-white placeholder-gray-400 focus:outline-none focus:ring-2 
                        focus:ring-yellow-500 focus:border-transparent"
                    />
                    <ValidationErrorMessage
                      message={errors.phonenumber?.message}
                    />
                  </div>

                  {/* Gender - Added to match the second component */}
                  <div>
                    <label
                      htmlFor="gender"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      جنسیت
                    </label>
                    <select
                      defaultValue=""
                      id="gender"
                      {...register("gender")}
                      className="w-full px-4 py-3 bg-[#171d3f] border border-gray-300 rounded-lg 
                        text-white placeholder-gray-400 focus:outline-none focus:ring-2 
                        focus:ring-yellow-500 focus:border-transparent"
                    >
                      <option value="" disabled selected>
                        جنسیت
                      </option>
                      <option value="1">مرد</option>
                      <option value="2">زن</option>
                    </select>
                    <ValidationErrorMessage message={errors.gender?.message} />
                  </div>

                  {/* Accept Rules Checkbox */}
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="acceptRules"
                      checked={isAcceptRule}
                      onChange={() => setIsAcceptRule(!isAcceptRule)}
                      className="h-4 w-4 text-yellow-500 focus:ring-yellow-400 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="acceptRules"
                      className="mr-2 block text-sm text-black"
                    >
                      ورود شما به معنای{" "}
                      <span
                        onClick={() => setIsShowAcceptRule(true)}
                        className="text-yellow-600 underline cursor-pointer"
                      >
                        پذیرش قوانین
                      </span>{" "}
                      سامانه است.
                    </label>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={!isAcceptRule}
                    className={`w-full py-3 text-white font-medium rounded-lg transition duration-200 shadow-md
                      ${
                        isAcceptRule
                          ? "bg-[#153477] hover:bg-yellow-600"
                          : "bg-gray-300 cursor-not-allowed"
                      }`}
                  >
                    ثبت نام
                  </button>
                </form>

                {/* Login Link */}
                <div className="mt-6 text-center">
                  <p className="text-sm text-gray-600">
                    حساب کاربری دارید؟{" "}
                    <Link
                      to="/"
                      className="text-yellow-600 hover:text-yellow-700 font-medium underline"
                    >
                      ورود
                    </Link>
                  </p>
                </div>
              </div>

              {/* Verify Code Section */}
              <div className={`${isChange ? "block" : "hidden"}`}>
                <form onSubmit={handleSubmit(handleSignUp)}>
                  <div className="space-y-4">
                    <label
                      htmlFor="verifyCode"
                      className="block text-sm font-medium text-white mb-2"
                    >
                      کد تأیید
                    </label>
                    <div
                      className="flex justify-center"
                      style={{ direction: "ltr" }}
                    >
                      <OtpInput
                        value={signUpCode}
                        onChange={setSignUpCode}
                        numInputs={5}
                        renderInput={(props) => (
                          <input
                            {...props}
                            className="w-12 h-12 mx-1 text-center bg-[#153477] border border-gray-300 
                              rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-yellow-500 
                              focus:border-transparent"
                            style={{ direction: "rtl" }}
                          />
                        )}
                        containerStyle="flex justify-center"
                      />
                    </div>
                    <p className="text-center text-gray-600 text-sm mt-2">
                      زمان باقی مانده:{" "}
                      <span
                        id="verificationCodeCountDown"
                        className="text-yellow-600 font-medium"
                      >
                        120
                      </span>{" "}
                      ثانیه
                    </p>
                    <button
                      type="submit"
                      className="w-full py-3 bg-[#153477] hover:bg-yellow-600 border border-gray-300 text-white font-medium 
                        rounded-lg transition duration-200 shadow-md"
                    >
                      تأیید ثبت نام
                    </button>
                  </div>
                </form>
              </div>

              {/* PWA Install Button */}
              {showInstallButton && (
                <button
                  onClick={handleInstallClick}
                  className="w-full mt-6 py-3 bg-gray-800 hover:bg-gray-700 text-white 
                    font-medium rounded-lg transition duration-200 flex items-center justify-center shadow-md"
                >
                  {window.innerWidth > 768 ? (
                    <MdInstallDesktop size={20} className="ml-2 text-white" />
                  ) : (
                    <MdInstallMobile size={20} className="ml-2 text-white" />
                  )}
                  نصب نسخه تحت وب
                </button>
              )}

              {/* Rules Modal */}
              {isShowAcceptRule && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                  <div className="bg-[#153477] text-white rounded-lg shadow-lg w-11/12 md:w-2/3 max-h-[80vh] overflow-y-auto p-6">
                    <h2 className="text-xl font-bold mb-4 text-yellow-600">
                      قوانین سایت
                    </h2>
                    <div className="space-y-4 text-justify text-sm">
                      <p>
                        سامانه شادمهر تابع قوانین جمهوری اسلامی ایران بوده و
                        بستری برای معامله فلزات گرانبهایی از قبیل طلا آبشده و
                        تمام سکه و نیم سکه و ربع سکه با ریال می‌باشد.
                      </p>
                      <p>
                        1- کاربران سایت می‌پذیرند که کلیه‌ی فعالیت‌های آن‌ها در
                        سامانه شادمهر در چارچوب قوانین جمهوری اسلامی بوده و هیچ
                        گونه فعالیتی خارج از این چارچوب انجام نخواهند داد.
                      </p>
                      <p>
                        2- احراز هویت برای استفاده از خدمات سامانه ضروری بوده و
                        کاربران موظفند اطلاعات صحیح خود را بارگذاری نمایند.
                      </p>
                    </div>
                    <div className="mt-6 text-left">
                      <button
                        onClick={() => setIsShowAcceptRule(false)}
                        className="px-4 py-2 bg-[#153477] hover:bg-yellow-600 border border-gray-300 text-white rounded"
                      >
                        بستن
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
